module.exports = __webpack_public_path__ + "img/pinch_zoom.6432aa27.gif";